module.exports = __webpack_public_path__ + "img/icon(19).45972d6e.png";